import * as React from "react";
import { forwardRef } from "react";
const SvgChatAttachment = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", "data-svgr-icon": "true", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M13 4H4.81445C3.70988 4 2.81445 4.89543 2.81445 6V15C2.81445 16.1046 3.70988 17 4.81445 17H15.8145C16.919 17 17.8145 16.1046 17.8145 15V9M13 4L15.5 6.5L17.8145 9M13 4V7C13 8.10457 13.8954 9 15 9H17.8145", stroke: "#737B7E" }));
const ForwardRef = forwardRef(SvgChatAttachment);
export { ForwardRef as ReactComponent };
